export const CATEGORIES_BY_INDUSTRY = {
  Insurance: [
    "Accident",
    "Auto",
    "Disability",
    "Health",
    "Life",
    "Long Term Care",
    "Property & Casualty",
    "Variable Annuity",
    "Other",
  ],
  "Real Estate": [
    "Sales Associate",
    "Broker Associate",
    "Broker",
    "Licensed Real Estate Appraiser",
    "Real Estate Appraiser Trainee",
    "Certified Residential Real Estate Appraiser",
    "Certified General Real Estate Appraiser",
    "Other",
  ],
  Mortgage: [
    "Mortgage Loan Originator",
    "Other",
  ],
  "Financial Services": [
    "Investment Adviser Representative (IAR)",
    "Securities Agent (State-Registered)",
    "Other",
  ],
};

const FALLBACK_CATEGORIES = ["Other"];

export const getCategoriesForIndustry = (industry) => {
  const list = CATEGORIES_BY_INDUSTRY[industry];
  if (Array.isArray(list) && list.length > 0) return list;
  return FALLBACK_CATEGORIES;
};

export const mergeCategoriesByIndustry = (dynamic = {}) => {
  const merged = { ...dynamic };
  for (const [industry, categories] of Object.entries(CATEGORIES_BY_INDUSTRY)) {
    const existing = Array.isArray(merged[industry]) ? merged[industry] : [];
    const next = [];
    const seen = new Set();
    for (const item of [...categories, ...existing]) {
      const value = String(item || "").trim();
      if (!value || seen.has(value)) continue;
      seen.add(value);
      next.push(value);
    }
    merged[industry] = next;
  }
  return merged;
};
